import { render, staticRenderFns } from "./ResendVerify.vue?vue&type=template&id=0c08955b&"
import script from "./ResendVerify.vue?vue&type=script&lang=js&"
export * from "./ResendVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports